/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestUniswapV3NonFungibleTokenManager extends Contract<ITestUniswapV3NonFungibleTokenManager> {
  positions: Call<(_tokenId: BigNumberish) => { nonce_: BigNumber, operator_: string, token0_: string, token1_: string, fee_: BigNumber, tickLower_: BigNumber, tickUpper_: BigNumber, liquidity_: BigNumber, feeGrowthInside0LastX128_: BigNumber, feeGrowthInside1LastX128_: BigNumber, tokensOwed0_: BigNumber, tokensOwed1_: BigNumber }, ITestUniswapV3NonFungibleTokenManager>
  'positions(uint256)': Call<(_tokenId: BigNumberish) => { nonce_: BigNumber, operator_: string, token0_: string, token1_: string, fee_: BigNumber, tickLower_: BigNumber, tickUpper_: BigNumber, liquidity_: BigNumber, feeGrowthInside0LastX128_: BigNumber, feeGrowthInside1LastX128_: BigNumber, tokensOwed0_: BigNumber, tokensOwed1_: BigNumber }, ITestUniswapV3NonFungibleTokenManager>
}

let ITestUniswapV3NonFungibleTokenManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestUniswapV3NonFungibleTokenManagerBytecode = '0x';
}

// prettier-ignore
export const ITestUniswapV3NonFungibleTokenManager = contract<ITestUniswapV3NonFungibleTokenManager>(ITestUniswapV3NonFungibleTokenManagerBytecode)`
  function positions(uint256 _tokenId) view returns (uint96 nonce_, address operator_, address token0_, address token1_, uint24 fee_, int24 tickLower_, int24 tickUpper_, uint128 liquidity_, uint256 feeGrowthInside0LastX128_, uint256 feeGrowthInside1LastX128_, uint128 tokensOwed0_, uint128 tokensOwed1_)
`;